var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{tag:"component",class:_vm.className,style:(_vm.style),attrs:{"href":_vm.href}},[_c('img',{staticClass:"media-image",class:this.circle ? 'rounded-circle' : '',attrs:{"src":_vm.src,"alt":_vm.alt}})])}
var staticRenderFns = []

export { render, staticRenderFns }